import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const CustomerStore = {
  namespaced: true,
  state: {
  },
  getters,
  mutations,
  actions
}

export default CustomerStore
